module.exports = __webpack_public_path__ + "img/Villa_Borna_62.55bb3c53.jpg";